import {
  GetMyPersonalityTestAnswersDto,
  useMyPersonalityTestAnswers,
} from "@/api/user/useMyPersonalityTestAnswers";
import { removePersonalityTestFormData } from "@/components/PersonalityTest/personalityTestStorage";
import { StyledActionButton } from "@/components/shared/StyledActionButton";
import { Alert, Box, Card, Center, Loader, Stack, Text, Title } from "@mantine/core";
import { useEffect } from "react";
import { NavLink } from "react-router-dom";

function getAnswerDisplay(answer: GetMyPersonalityTestAnswersDto) {
  if (answer.answerText) {
    return `"${answer.answerText}"`;
  }
  if (answer.answerScale !== null && answer.answerScale !== undefined) {
    return `선택: ${answer.answerScale}`;
  }
  if (answer.selectedOptions && answer.selectedOptions.length > 0) {
    return answer.selectedOptions
      .map((selectedOption) => selectedOption.option.displayText)
      .join(", ");
  }
  return "답변이 없습니다.";
}

export function PersonalityTestAnswersPage() {
  const { data: answers, isLoading, isError } = useMyPersonalityTestAnswers();

  // just in case there's any stale form data left over from the previous test
  // we don't want the user to retake the personality test again and accidentally submit stale answers
  useEffect(() => {
    removePersonalityTestFormData();
  }, []);

  if (isLoading) {
    return (
      <Center style={{ height: "100%" }}>
        <Loader color="white" />
      </Center>
    );
  }

  if (isError) {
    return (
      <Alert title="오류" color="red" mt="lg">
        취향 테스트 결과를 불러올 수 없습니다. 나중에 다시 시도해주세요.
      </Alert>
    );
  }

  if (!answers || answers.length === 0) {
    return <Text c="dimmed">아직 완료된 성격 테스트가 없습니다.</Text>;
  }

  return (
    <Stack justify="space-between" my="xl">
      <Stack>
        <Title order={1} c="white" ta="center" mb="xl">
          나의 취향 테스트 결과
        </Title>
        <Box p="xl">
          <Stack gap="lg">
            {answers.map((answer) => (
              <Card key={answer.id} p="md" radius="sm" withBorder>
                <Text fw={500} size="lg">
                  {answer.question.title}
                </Text>
                <Text color="dimmed" mt="xs">
                  {getAnswerDisplay(answer)}
                </Text>
              </Card>
            ))}
          </Stack>
        </Box>
      </Stack>

      <Center>
        <StyledActionButton
          size="md"
          component={NavLink}
          to="/personality-test?isPersonalityTestOnly=true"
        >
          취향 테스트 다시보기
        </StyledActionButton>
      </Center>
    </Stack>
  );
}
